import React, { memo } from "react";
import { observer } from "mobx-react";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { Grid, Tooltip } from "@material-ui/core";
import TableComponent from "app/common/Component/Table/TableComponent";
import { useTranslation } from "react-i18next";
import {
  LAVoucherItemRevenueType,
  TYPE_CARD,
  VOUCHER_INVOICE_TYPE,
  VOUCHER_STATUS,
  VOUCHER_STATUS_VALUE,
  VOUCHER_TYPE_VALUE,
} from "app/common/LocalConst";
import {
  formatMoney,
  formatNumber,
  getDateTime,
  getGender,
} from "app/common/LocalFunction";

function HistoryPatientPopup({
  open,
  handleClose,
  searchData,
  pageDataPatientHistory,
  handleChangeFormSearch,
}) {
  const { t } = useTranslation();

  return (
    <PopupForm
      size="lg"
      title="Lịch sử khách hàng"
      open={open}
      handleClose={handleClose}
      formik={{
        initialValues: searchData,
      }}
      hideSubmit
    >
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          className="justify-center cards-body pt-0 mt-2"
          style={{
            zIndex: 1,
            position: "relative",
          }}
        >
          <TableComponent
            className=""
            showOrdinalNumbers
            titleNodata={t("noData")}
            data={pageDataPatientHistory?.content}
            name="PatientHistory"
            showMoreButton
            minWidth={"1000"}
            rowCss={(row) =>
              VOUCHER_STATUS.find((el) => el?.value === row?.status)?.className
            }
            columns={[
              {
                field: "createDateLog",
                title: t("TG lưu vết"),
                render: (row) => getDateTime(row?.createDateLog),
              },
              {
                field: "username",
                title: t("TK thay đổi"),
              },
              {
                field: "displayName",
                title: t("Tên khách hàng"),
                render: (patient) => (
                  <div>
                    <Tooltip title="Thông tin khách hàng">
                      <div>
                        <p>
                          <b>{patient?.fullName}</b>
                        </p>
                        <p className="flex">
                          <b style={{ color: "#4276a4" }}>{patient?.code} </b>
                        </p>
                      </div>
                    </Tooltip>
                  </div>
                ),
              },

              {
                field: "phoneNumber",
                title: t("Số điện thoại"),
              },

              {
                field: "phoneNumber2",
                title: t("Số điện thoại 2"),
              },

              {
                field: "phoneNumber3",
                title: t("Số điện thoại 3 "),
              },

              {
                field: "phoneNumber4",
                title: t("Số điện thoại 4"),
              },
              {
                title: "Nguồn đầu tiên",
                width: 100,
                render: (data) => (
                  <div>
                    <div>
                      <b>Nguồn:</b> {data?.firstPatientSource?.name || ""}
                    </div>
                    <div>
                      <b>Chi tiết:</b>{" "}
                      {data?.firstPatientSourceDetail?.name || ""}
                    </div>
                  </div>
                ),
              },
              {
                title: "Nguồn hiện tại",
                width: 100,
                render: (data) => (
                  <div>
                    <div>
                      <b>Nguồn:</b> {data?.currentPatientSource?.name || ""}
                    </div>
                    <div>
                      <b>Chi tiết:</b>{" "}
                      {data?.currentPatientSourceDetail?.name || ""}
                    </div>
                  </div>
                ),
              },
              {
                title: "Telesale 1",
                render: (data) => {
                  // console.log("Row data:", data);
                  return data?.currentTelesale?.staffName || "";
                },
              },
              {
                title: "Telesale 2",
                render: (data) => {
                  // console.log("Row data:", data);
                  return data?.currentTelesale2?.staffName || "";
                },
              },
              {
                title: "CSKH hiện thời",
                render: (data) => {
                  // console.log("Row data:", data);
                  return data?.currentCustomerCareAgent?.staffName || "";
                },
              },

              {
                field: "referralPartnerName",
                title: t("CTV"),
                width: "100px",
                render: (patient) => (
                  patient?.referralPartnerName && patient?.referralPartnerCode ? (
                    <div>
                      <div>
                        <b>Tên:</b> {patient.referralPartnerName}
                      </div>
                      <div>
                        <b>Mã:</b> {patient.referralPartnerCode}
                      </div>
                    </div>
                  ) : null
                ),
              },
              {
                field: "currentDep.name",
                title: t("Cơ sở hiện thời"),
                render: (row) => row?.currentDep?.name || "",
              },
              {
                field: "patientCreateDate",
                title: t("Ngày tạo Khách hàng"),
                render: (row) => getDateTime(row?.patientCreateDate),
              },

              // {
              //   field: "createDate",
              //   title: t("Thời gian tạo (theo hệ thống)"),
              //   render: (row) => getDateTime(row?.createDate),
              // },
            ].filter(Boolean)}
            dataPagination={{
              pageIndex: searchData?.pageIndex,
              pageSize: searchData?.pageSize,
              totalElements: pageDataPatientHistory?.totalElements,
              totalPages: pageDataPatientHistory?.totalPages,
              setPageIndex: (pageIndex) =>
                handleChangeFormSearch({ pageIndex }),
              setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
            }}
          />
        </Grid>
      </Grid>
    </PopupForm>
  );
}

export default memo(observer(HistoryPatientPopup));
